import { useContent } from "@/context/ContentContext";
import { Reveal } from "@/components/Reveal";

function H2({ children }) {
  return <h2 className="mt-8 mb-3 font-display text-xl font-semibold text-zinc-100">{children}</h2>;
}

function P({ children }) {
  return <p className="text-sm leading-relaxed text-zinc-300">{children}</p>;
}

export default function LegalPage({ kind }) {
  const c = useContent();
  const S = c.settings;
  const isImpressum = kind === "impressum";

  return (
    <main className="mx-auto max-w-3xl px-5 sm:px-8 pt-32 pb-24">
      <Reveal>
        <span className="font-mono text-xs uppercase tracking-[0.25em] font-semibold text-blue-400">
          Rechtliches
        </span>
        <h1 className="mt-4 font-display text-3xl sm:text-4xl font-bold tracking-tight text-zinc-100">
          {isImpressum ? "Impressum" : "Datenschutzerklärung"}
        </h1>

        {isImpressum ? (
          <div className="mt-8 flex flex-col gap-1">
            <H2>Angaben gemäß § 5 TMG</H2>
            <P>{S.company_name}</P>
            <P>Brockeler Str. 14B</P>
            <P>27356 Rotenburg</P>
            <P>Deutschland</P>

            <H2>Kontakt</H2>
            <P>
              Telefon: {S.phone_display || "–"} · E-Mail: {S.email}
            </P>

            <H2>Vertreten durch</H2>
            <P>Inhaber: {S.owner_name || "Lukas Wiese"}</P>

            <H2>Umsatzsteuer</H2>
            <P>Kleinunternehmer gemäß § 19 UStG – Umsatzsteuer wird nicht ausgewiesen.</P>

            <H2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</H2>
            <P>{S.owner_name || "Lukas Wiese"}, Anschrift wie oben.</P>

            <H2>Streitschlichtung</H2>
            <P>
              Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor
              einer Verbraucherschlichtungsstelle teilzunehmen.
            </P>
          </div>
        ) : (
          <div className="mt-8 flex flex-col gap-1">
            <H2>1. Verantwortlicher</H2>
            <P>
              {S.company_name}, Inhaber: {S.owner_name || "Lukas Wiese"}, Brockeler Str. 14B, 27356
              Rotenburg · E-Mail: {S.email}
              {S.phone_display ? ` · Telefon: ${S.phone_display}` : ""}
            </P>

            <H2>2. Kontakt- &amp; Terminanfragen</H2>
            <P>
              Wenn du uns über das Anfrageformular kontaktierst, verarbeiten wir die von dir
              angegebenen Daten (Name, bevorzugter Kontaktweg, Telefon und/oder E-Mail, PLZ/Ort,
              Fahrzeug, gewählte Leistung, ggf. Wunschtermin und Nachricht) ausschließlich zur
              Bearbeitung deiner Anfrage und zur Terminabstimmung (Art. 6 Abs. 1 lit. b DSGVO). Die
              Anfragen werden in der Datenbank unseres Anbieters gespeichert und gelöscht, sobald sie
              nicht mehr benötigt werden, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
            </P>

            <H2>3. Fahrzeugfotos</H2>
            <P>
              Bei Anfragen kannst du optional Fotos deines Fahrzeugs hochladen. Diese werden
              verschlüsselt übertragen, in einem geschützten Speicherbereich abgelegt und nur im
              passwortgeschützten Adminbereich angezeigt. Sie werden nicht öffentlich gezeigt und
              nach Bearbeitung deiner Anfrage gelöscht, sofern keine anderen Vereinbarungen getroffen
              wurden.
            </P>

            <H2>4. Hosting &amp; Datenbank</H2>
            <P>
              Die Website wird bei einem externen Hosting-Dienstleister betrieben. Beim Aufruf der
              Seite werden technisch notwendige Daten (z. B. IP-Adresse, Zeitpunkt des Zugriffs)
              verarbeitet. Die Inhalte aus dem Anfrageformular werden in einer Datenbank beim
              Hosting-Provider gespeichert.
            </P>

            <H2>5. Externe Schriftarten</H2>
            <P>
              Diese Website bindet Schriftarten von Google Fonts (Google Ireland Limited) ein. Beim
              Aufruf der Seite werden Daten (z. B. Ihre IP-Adresse) an Google-Server übermittelt und
              dort gespeichert. Rechtsgrundlage ist unser berechtigtes Interesse an einer
              einheitlichen Darstellung (Art. 6 Abs. 1 lit. f DSGVO).
            </P>

            <H2>6. E-Mail-Versand</H2>
            <P>
              Anfragen aus dem Formular werden per E-Mail an den Betreiber übermittelt. Hierbei
              kommt ein externer E-Mail-Versanddienst zum Einsatz.
            </P>

            <H2>7. Kein Tracking</H2>
            <P>
              Diese Website verwendet keine Analyse- oder Trackingdienste und setzt keine
              Marketing-Cookies.
            </P>

            <H2>8. Deine Rechte</H2>
            <P>
              Du hast jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
              Verarbeitung, Widerspruch und Datenübertragbarkeit (Art. 15–20 DSGVO). Wende dich
              dafür einfach an {S.email}. Zudem hast du das Recht, dich bei einer
              Datenschutz-Aufsichtsbehörde zu beschweren.
            </P>
          </div>
        )}
      </Reveal>
    </main>
  );
}